module.exports = __webpack_public_path__ + "img/HowToRegOutlined.8d073042.svg";